import { CATEGORIEFAQ, PAGINEDETAIL } from 'utils/endpoint'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import AccordionItem from 'components/atomic/AccordionItem'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { api } from 'utils'
import { ScrollUp, JsonLd } from 'react-components/atoms'
import { useRouter } from 'next/router'

const FaqPaginaDetail = React.memo(({ categorieFaq, page, statusCode }) => {
  if (!categorieFaq) return <Error statusCode={statusCode} />

  const router = useRouter()

  const scrollUpRef = useRef(null)

  const [basePath, setBasePath] = useState(router.asPath.split('#')[0])
  const [scrollUpVisible, setScrollUpVisible] = useState(false)

  const [paginaFaq, setPaginaFaq] = useState([])
  const [actualFaqs, setActualFaqs] = useState([])

  useEffect(() => {
    initializePaginaFaq()
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  })

  const handleScroll = () => {
    setScrollUpVisible(window.scrollY > scrollUpRef.current.offsetTop - 50)
  }

  const initializePaginaFaq = () => {
    if (categorieFaq.length > 0) {
      setPaginaFaq(categorieFaq[0].pagina_faq)
      showActualFaqs()
    }
  }

  const listFaq = useMemo(
    () =>
      categorieFaq.map((categoria, index) => (
        <div
          key={categoria.id + '_titolo'}
          className={
            'faq-page__autore__category' +
            (categoria.scelta ? ' faq-page__autore__category--active' : '')
          }
        >
          <p className={`faq-page__autore__category-title-mobile`} id={categoria.slug}>
            {categoria.nome}
          </p>
          <ul className={`faq-page__autore__category-faq-list`}>
            {categoria.faqs.map(faq => (
              <li key={faq.id}>
                <AccordionItem domanda={faq.domanda} risposta={faq.risposta} />
              </li>
            ))}
          </ul>
        </div>
      )),
    [categorieFaq, actualFaqs]
  )

  const selezionaCategoria = () => {
    const categoriaDefault = categorieFaq[0]

    const hash = window.location.hash.split('#')[1]
    if (!hash) {
      return categoriaDefault
    }

    const selected = categorieFaq.filter(x => x.slug == hash)
    return selected.length ? selected[0] : categoriaDefault
  }

  const showActualFaqs = categoria => {
    if (!categoria) {
      categoria = selezionaCategoria()
    }
    categorieFaq = categorieFaq.map(categoria => {
      categoria.scelta = false
      return categoria
    })
    categoria.scelta = true
    let actualFaqs = categoria.faqs.map(faq => (
      <li key={faq.id}>
        <AccordionItem domanda={faq.domanda} risposta={faq.risposta} />
      </li>
    ))

    setActualFaqs(actualFaqs)
  }

  return (
    <>
      {categorieFaq ? (
        <>
          <MetaSeo seo={page.seo} />
          <JsonLd item={categorieFaq} type="faq" />
          <ScrollUp visible={scrollUpVisible} />
          <main className="faq-page faq-page--detail">
            <div className="w-container">
              <Breadcrumbs breadcrumbs={page.breadcrumbs} />

              <section className="faq-page__header">
                <h1 className="faq-page__title">{paginaFaq.titolo}</h1>
                <p className="faq-page__description">{paginaFaq.descrizione}</p>
              </section>
              <div className="faq-page__autore__section">
                <section className="faq-page__autore__content">
                  <aside className="faq-page__autore__menu">
                    {categorieFaq.map(categoria => (
                      <a
                        key={categoria.id + '_nome'}
                        href={'#' + categoria.slug}
                        onClick={() => showActualFaqs(categoria)}
                      >
                        <p
                          className={`faq-page__autore__menu__item ${
                            categoria?.scelta ? 'active' : ''
                          }`}
                        >
                          {categoria.nome}
                        </p>
                      </a>
                    ))}
                  </aside>
                  <section className="faq-page__autore__summary">
                    {categorieFaq.map((c, index) => (
                      <a
                        className="faq-page__autore__summary__anchor"
                        href={`${basePath}#${c.slug}`}
                        key={index}
                      >
                        {c.nome}
                      </a>
                    ))}
                  </section>
                  <div ref={scrollUpRef}></div>
                  <section className="faq-page__autore__faqs">{listFaq}</section>
                </section>
              </div>
            </div>
          </main>
        </>
      ) : null}
    </>
  )
})

export const getServerSideProps = async ({ query: { slug }, res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${CATEGORIEFAQ}?utente_null=true&pagina_faq__slug=${slug}`, {
      headers,
    })
    let categorieFaq = await response.data

    if (res && categorieFaq.length === 0) {
      res.statusCode = 404
      return { statusCode: 404 }
    }
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'faq-pagina-detail',
      },
    })
    const page = await pageResponse.data
    const toolbarProps = { toolbarPage: page }

    return { props: { categorieFaq, page, ...toolbarProps } }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default FaqPaginaDetail
